import { DestroyRef, Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// import { DateAdapter } from '@angular/material/core';
// services
import { NetworkService } from './network.service';

// locale date
// import { registerLocaleData } from '@angular/common';



@Injectable()
export class TranslateService {

  private readonly destroyRef = inject(DestroyRef);
  public data: any = {};
  public defaultData: any = {};
  public actualLang: string;
  public defaultLang: string;
  public actualLocale: string;
  public actualLangChange = new Subject<string>();
  public langs = ['es', 'en', 'th', 'fr', 'pt', 'it', 'zh', 'ko'];
  public global_langs = ['es', 'en', 'th', 'fr', 'pt', 'it', 'zh', 'ko'];
  public locales = {
    es: "es-mx",
    en: "en-ca",
    th: "th",
    fr: "fr",
    pt: "pt",
    it: "it",
    zh: "zh-cn",
    ko: "ko"
  }
  constructor(private http: HttpClient, 
    // private _adapter: DateAdapter<any>, 
    private networkService: NetworkService) {
    this.actualLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.actualLang = value;
      this.actualLocale = this.locales[value];
    });
  }

  /**
   * Set language
   * @param lang
   * @param uid
   */
  use(lang: string): Promise<{}> {

    return new Promise<{}>((resolve, reject) => {
      if (typeof lang === 'undefined' || this.langs.indexOf(lang) === -1) {
        lang = 'es';
      }
      
      this.networkService.status_sub
        .pipe(take(1), takeUntilDestroyed(this.destroyRef))
        .subscribe((status: boolean) => {
        // console.log(" translateService use() network status", value);
        if (status) {
          
          const langPath = `assets/i18n/${lang}.json`;
          this.http.get<{}>(langPath).subscribe(
            translation => {
              this.data = Object.assign({}, translation || {});

              localStorage.setItem('lang', lang);
              localStorage.setItem('actual-translation', JSON.stringify(this.data));
              this.actualLangChange.next(lang);
              resolve(this.data);
            },
            error => {
              this.data = {};
              localStorage.setItem('lang', lang);
              this.actualLangChange.next(lang);
              resolve(this.data);
            }
          );
        } else {
          const trans_data_str = localStorage.getItem('actual-translation');
          this.actualLangChange.next(lang);

          this.data = (trans_data_str != undefined) ? JSON.parse(trans_data_str) : {};
          // console.log("this.data", this.data);

          resolve(this.data);
        }
      })


    });
  }

  /**
  * @author Matías Villar
  * @date 04-07-2023
  * @description Set default language from survey property
  * @returns {Promise<{}>} with the default language.
  */
  async setDefaultLang(lang: string) {
    this.networkService.status_sub
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe((status: boolean) => {
      if (status) {
        
        const langPath = `assets/i18n/${lang}.json`;
        this.http.get<{}>(langPath).subscribe(
          translation => {
            this.defaultData = Object.assign({}, translation || {});

            localStorage.setItem('default-lang', lang);
            localStorage.setItem('default-translation', JSON.stringify(this.data));
          },
          error => {
            this.data = {};
            localStorage.setItem('default-lang', lang);
          }
        );
      } else {
        const trans_data_str = localStorage.getItem('default-translation');
        this.actualLangChange.next(lang);

        this.data = (trans_data_str != undefined) ? JSON.parse(trans_data_str) : {};
        this.data;
      }
    })
  }

  getBrowserLang() {
    // Check user's preferred languages first (more accurate for content)
    const languages = navigator.languages || [navigator.language];
      
    // Try to find a supported language from user's preferences
    for (const lang of languages) {
      const langCode = lang.slice(0, 2).toLowerCase();
      if (this.langs.includes(langCode)) {
        return langCode;
      }
    }
    
    // Fallback to first language if none supported
    const fallbackLang = languages[0].slice(0, 2).toLowerCase();
    return fallbackLang;
  }
  updateLangs(langs: Array<string>) {
    this.langs = langs;
  }
  resetLangs() {
    this.langs = this.global_langs;
  }
}
